import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip, Modal } from '@mui/material';
import AsyncSelect from 'react-select/async';

function ItemIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const [open, setOpen] = useState(false);
    const [selectedItemOption, setSelectedItemOption] = useState(null);
    const [itemsOptions, setItemsrOptions] = useState([]);

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const response = await fetchData('SaleApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {

                setItemsrOptions(response.response_data);
            }

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleItemChange = (newValue) => newValue;
    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }


        try {
            // Fetch data from the API
            const response = await fetchData('SaleApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    //setItemsrOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                        BarCode: item.BarCode
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };


    const handlePrint = () => {
        console.log("Selected Item Option in Print Function:", selectedItemOption);

        if (!selectedItemOption?.BarCode) {
            console.error("Error: Barcode is missing or undefined.");
            return;
        }

        const barcodeNumber = selectedItemOption.BarCode;
        console.log("Printing Barcode:", barcodeNumber);

        const printWindow = window.open('', '', 'width=400,height=300');

        if (!printWindow) {
            console.error("Popup blocked or failed to open.");
            return;
        }

        printWindow.document.open();
        printWindow.document.write(`
                <html>
                    <head>
                        <title>Barcode Print</title>
                        <style>
                            @media print {
                                body {
                                    font-size: 40px;
                                    font-weight: bold;
                                    text-align: left;
                                    padding: 20px;
                                }
                            }
                        </style>
                        <script>
                            window.onafterprint = function() {
                                window.close();
                            };
                        </script>
                    </head>
                    <body>
                        ${barcodeNumber}
                    </body>
                </html>
            `);

        printWindow.document.close();

        // Ensure content is loaded before printing
        setTimeout(() => {
            printWindow.focus();
            printWindow.print();
        }, 500);
    };




    //search

    useEffect(() => {
        if (!searchTerm.trim()) {
            setFilteredData(data); // Reset filteredData if searchTerm is empty
        } else {
            const filtered = data.filter(item =>
                item.Name?.toLowerCase().includes(searchTerm.toLowerCase()) // Safe access operator for item.Name
            );
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);

    const fetchtableData = async () => {
        fetchData('ItemApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    setFilteredData(response.response_data); // Ensure filteredData is initialized
                }
            })
            .catch((error) => {
                console.error('Error fetching Item Details:', error);
                if (error.response && error.response.status === 401) {
                    logout();
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };

    const handleDelete = async () => {
        deleteData('ItemApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ItemApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className='w-full mb-2 flex'>
                <h5 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item</h5>
                <div className='w-1/4 mb-2 flex'>
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    />
                </div>
                {/* Barcode Print Button */}
                <Button
                    style={{
                        background: '#134B70',
                        padding: '10px 20px',
                        color: 'white',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        marginLeft: '10px'
                    }}
                    onClick={() => setOpen(true)}
                >
                    Barcode
                </Button>
                {hasCreateMasterPermission && (
                    <Tooltip title="Item Registration">

                        <Button
                            style={{
                                background: 'linear-gradient(to right, #16423C,#6A9C89)',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '35px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: '5px'
                            }}
                            component={Link}
                            to="/ItemCreate"
                        >
                            + ADD ITEM
                        </Button>
                    </Tooltip>
                )}

            </div>

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#134B70' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', width: '3%' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', width: '15%' }}>Category</TableCell>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', width: '30%' }}>Item Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', width: '10%' }}>Unit</TableCell>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', width: '7%' }}>GST %</TableCell>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', width: '10%' }}>HSN Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', width: '10%' }}>Bar Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#134B70', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', width: '10%' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#C3E9E4' }}>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    className={item.IsActive ? '' : 'inactiveRow'}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F5F5F5', // Alternates between white and light grey
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '3%', fontSize: '14px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '15%', fontSize: '14px' }}>{item.ItemCategoryName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '30%', fontSize: '14px' }}>{item.Name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.UnitofMeasureName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '7%', fontSize: '14px' }}>{(item.CGSTRate) + (item.SGSTRate)}%</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.HSNCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.BarCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '15%', fontSize: '14px' }}>
                                        {hasEditMasterPermission && (
                                            <Link to={`/ItemEdit/${item.Id}`}>
                                                <IconButton color="primary">
                                                    <EditIcon style={{ height: '22px' }} />
                                                </IconButton>
                                            </Link>
                                        )}

                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))} color="error">
                                                {item.IsActive ? <DeleteIcon style={{ color: 'brown', height: '22px' }} /> : <ActivateIcon style={{ color: 'darkolivegreen', height: '22px' }} />}
                                            </IconButton>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>

                    </Table>
                </TableContainer>
            </div>
            {/* Modal for Barcode Selection */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <div className="modal-content p-4 bg-white shadow-lg mx-auto mt-20 max-w-sm rounded-lg">
                    <h3 className="text-lg font-bold mb-2">Select Item for Barcode</h3>
                    <div className="w-4/5 mr-2 flex items-center">
                        <label
                            className="block uppercase tracking-wide text-black text-xs font-bold mr-2"
                            htmlFor="Weightage"
                        >
                            Item Name
                        </label>
                        <AsyncSelect
                            cacheOptions
                            onInputChange={handleItemChange}
                            loadOptions={fetchItemOptions}
                            onChange={setSelectedItemOption}
                            value={selectedItemOption}
                            className="flex-grow"
                        />
                    </div>
                    <Button
                        style={{ background: '#28a745', color: 'white', padding: '10px 15px', marginTop: '10px' }}
                        onClick={handlePrint}
                    >
                        Print
                    </Button>
                </div>
            </Modal>
        </div >
    );
}

export default ItemIndex;

